import React from "react";
import { withStyles } from "@material-ui/styles";

import colors from "../../../assets/style/colors";
import { Checkbox, Dialog } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import ProfileMatchExpress from "../../SiteEntranceExit/CorrectConfirmValue/ProfileMatchExpress";
import { DialogTitle } from "@material-ui/core";
import CloseIcon from "../../Common/CloseIcon";
import { I18n } from "@aws-amplify/core";
import { DialogContent } from "@material-ui/core";
import NativeSelect from "@material-ui/core/NativeSelect";
import { OutlinedInput } from "@material-ui/core";
import { connect } from "react-redux";
import { get, map, flatten } from "lodash";
import FormSection from "../../Common/FormSection";
import images from "../../../assets/img/images";
import { Radio } from "@material-ui/core";
import { RadioGroup } from "@material-ui/core";
import { FormControlLabel } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { Button } from "@material-ui/core";
import TimeZone from "./TimeZone";
import { fetchGet, fetchPost } from "../../../api/fetch";
import ProfileSearchInput from "../../Common/ProfileSearchInput"
import CustomInput from "../../Common/CustomInput";
import { getLov } from "../../../utils/lov";
import { setSchedulerFilters } from "../../../actions/scheduler";
import DatePicker from "../../Common/DatePicker";

import {
    filter,
    size,
    // indexOf,
    // includes,
    forEach
} from "lodash";

import update from "immutability-helper";


import $ from 'jquery';
import "./tablestyles.css";

const styles = (theme) => ({
    inputLabel: {
        color: colors.black87,
        fontWeight: "500",
        marginTop: "24px",
        fontSize: "1em"
    },
    input: {
        height: "40px"
    },
    dialog: {
        maxWidth: "300px",
    },
    title: {
        textTransform: "uppercase",
        color: "black",
        fontWeight: 500,
    },
    radioGroup: {
        flexDirection: "row",
    },
    formControlRoot: {
        marginRight: "24px",
    },
    plusIcon: {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
    },
    select: {
        paddingTop: 0,
        paddingBottom: 0,
        height: "40px",
        fontSize: "0.875em",
    },
    tableTitle: {
        fontWeight: 500,
        color: "black"
    },
    input: {
        height: "40px",
    },
    dialogTitle: {
        fontSize: "1.142em",
        color: colors.black87,
        textAlign: "center",
        textTransform: "uppercase",
    },
    close: {
        background: "none",
        '&:hover': {
            background: "blue",
        },
    },
    closeIcon: {
        display: "flex",
        justifyContent: "flex-end",
    },
    closeFile: {
        top: -2,
        left: 10,
        cursor: "pointer"
    },
    dialogPaper: {
        minWidth: '915px',
        minHeight: '597px'
    },
    dialogPaper2: {
        minWidth: '1242px',
        minHeight: '602px',
    },
    details: {
        marginTop: 5,
        left: -230
    },
    header: {
        fontWeight: 500,
        color: "black"
    },
    detailsCheckBox: {
        left: 60,
        color: "black"
    },
    tabStyle: {
        right: 7,
        fontWeight: 500,
        color: "black"
    }
});


const Reservation = (props) => {
    const { classes, type, setOpen, companies, filters, handleFiltersChange, dispatch, typeId, tabsOriginal } = props;
    const [summary, setSummary] = React.useState(false)
    const [carrier, setCarrier] = React.useState(0)
    const [carriers, setCarriers] = React.useState([])
    const [carrierCall, setCarrierCall] = React.useState(false)
    const [trailer, setTrailer] = React.useState(3)
    const [tabs, setTabs] = React.useState(tabsOriginal)
    const [current, setCurrent] = React.useState(0)
    const [view, setView] = React.useState('0')
    const [master_date, setMasterDate] = React.useState("")
    const [timeZone, openTimeZone] = React.useState(false)
    const [currentFile, setFile] = React.useState([]);
    const [tabsHeight, setTabsHeight] = React.useState(500)
    const [tableHeight, setTableHeight] = React.useState(0)
    const [currentFileData, setFileData] = React.useState([])
    const [fileDataNumber, setFileDataNumber] = React.useState([])
    const [details, toggleDetails] = React.useState(false)
    const [detailsTab, toggleDetailsTab] = React.useState(false)
    const [reservationName, setReservationName] = React.useState("")
    const [reservationColor, setReservationColor] = React.useState(0)
    const [reservationDescription, setReservationDescription] = React.useState("")
    const [master_colors, setColors] = React.useState()
    const [initiated, setInitiated] = React.useState(false)
    const [, forceUpdate] = React.useReducer(x => x + 1, 0);

    const getCarriers = async () => {
        return await fetchGet(`attributes/89`)

    }
    if (!carrierCall) {
        getCarriers().then((data) => { setCarriers(data["values"]); setCarrierCall(true) })
    }

    const handleChangePOBOL = (e) => {
        var id = e.target.id
        var lastChar = id.substr(id.length - 1);
        tabs[current][10][parseInt(lastChar)] = e.target.value
        currentFileData[parseInt(lastChar)] = e.target.value
        forceUpdate()
    }

    function handleFileNumber(value, i) {
        fileDataNumber[i] = value
        tabs[current][11][i] = value
        forceUpdate()
    }

    function tabSwitch(id) {
        setCurrent(id)
        setTrailer(tabs[id][0])
        setView(tabs[id][1])
        setFile(tabs[id][5])
        if (tabs[id][13]) {
            setTabsHeight(500 + (tabs[id][5].length * (60)) + 250)
        } else {
            setTabsHeight(500 + (tabs[id][5].length * (60)))
        }
        setTableHeight(tabs[id][5].length * 60)
        setFileData(tabs[id][10])
        setFileDataNumber(tabs[id][11])
        toggleDetailsTab(tabs[id][13]);
        setFormValues({
            dateType: "current",
            date: Date.now(),
            profiles: [tabs[id][6]],
        })

        setFormValues2({
            dateType: "current",
            date: Date.now(),
            profiles: [tabs[id][23], tabs[id][24]],
        })
    }

    React.useEffect(() => {
        // Update the document title using the browser API
        const initiate = async () => {
            try {
                setColors(await getLov("colors"));
            } catch (e) {
                console.log(e)
            }
            setInitiated(true);
        }
        if (!initiated) initiate();
        let now = new Date();
        setMasterDate(now.toDateString())
    }, [initiated]);

    const handleClose = () => {
        setOpen(false);
    };

    const initialFormValues = {
        dateType: "current",
        date: Date.now(),
        profiles: [],
    };

    function detailTabs(bool) {
        toggleDetailsTab(bool);
        if (bool) {
            setTabsHeight(500 + (tabs[current][5].length * (60)) + 250)
        } else {
            setTabsHeight(500 + (tabs[current][5].length * (60)))
        }
    }

    function uploadFile(e, id) {
        currentFile[id] = e.target.files[0]
        tabs[current][5] = currentFile
        forceUpdate()
    }

    const dataCreation = () => {
        currentFile.push("")
        tabs[current][5] = currentFile
        if (tabs[current][13]) {
            setTabsHeight(500 + (tabs[current][5].length * (60)) + 250)
        } else {
            setTabsHeight(500 + (tabs[current][5].length * (60)))
        }

        setTableHeight(tabs[current][5].length * 60)
        tabs[current][10].push(0)
        tabs[current][11].push("")
        setFileData(tabs[current][10])
    }

    const [formValues, setFormValues] = React.useState(initialFormValues);
    const [formValues2, setFormValues2] = React.useState(initialFormValues);

    const handleChange = (id, index, value) => {
        if (id === "addProfile") {
            if (index === 1) {
                tabs[current][23] = value //23rd element is the driver for each tab
                if (size(get(formValues2, ["profiles"])) < 8) {
                    setFormValues2(
                        update(formValues2, {
                            profiles: { $push: [value] },
                        })
                    );
                }
            } else if (index === 2) {
                tabs[current][24] = value //24rd element is the vehicle for each tab
                if (size(get(formValues2, ["profiles"])) < 8) {
                    setFormValues2(
                        update(formValues2, {
                            profiles: { $push: [value] },
                        })
                    );
                }
            } else {
                tabs[current][6] = value //6th element is the trailer/container for each tab
                if (size(get(formValues, ["profiles"])) < 8) {
                    setFormValues(
                        update(formValues, {
                            profiles: { $push: [value] },
                        })
                    );
                }
            }
            

        } else if (id === "removeProfile") {
            if (index === 1) {
                if (value === tabs[current][23]) {
                    tabs[current][23] = ""
                } else if (value === tabs[current][24]) {
                    tabs[current][24] = ""
                }
                forEach(get(formValues2, ["profiles"]), (p, i) => {
                    if (p.id === value.id) {
                        index = i;
                    }
                });
                setFormValues2(
                    update(formValues2, {
                        profiles: { $splice: [[index, 1]] },
                    })
                );
            } else {
                tabs[current][6] = ""
                forEach(get(formValues, ["profiles"]), (p, i) => {
                    if (p.id === value.id) {
                        index = i;
                    }
                });
                setFormValues(
                    update(formValues, {
                        profiles: { $splice: [[index, 1]] },
                    })
                );
            }

        }
    }

    const activeSite = get(
        filter(
            flatten(map(props.companies, (c) => c.sites)),
            (s) => s.id === filters["site"]
        ),
        [0]
    );

    const zones = filter(
        get(activeSite, ["zones"]),
        (z) =>
            z.active &&
            z.is_human_access &&
            (get(props, ["eventGroupType", "id"]) === 4
                ? z.is_entrance
                : get(props, ["eventGroupType", "id"]) === 5
                    ? z.is_exit
                    : true)
    );

    const renderProfile = (p) => {
        return (
            <Box
                style={{
                    margin: "10px 0px",
                    backgroundColor: colors.lightGrey,
                }}
            >
                <ProfileMatchExpress
                    profile={p}
                    style={{
                        padding: 0,
                        margin: "10px 0px"
                    }}
                    handleClose={handleChange}
                />
            </Box>
        );
    };

    const renderProfile2 = (p) => {
        return (
            <Box
                style={{
                    margin: "10px 0px",
                    backgroundColor: colors.lightGrey,
                }}
            >
                <ProfileMatchExpress
                    profile={p}
                    allow={false}
                    style={{
                        padding: 0,
                        margin: "10px 0px"
                    }}
                    handleClose={handleChange}
                />
            </Box>
        );
    };

    const excludeProfileIds = map(
        filter(get(formValues, ["profiles"]), (p) => get(p, ["id"])),
        (p) => get(p, ["id"])
    );


    const handleChangeCarrier = (e) => {
        setCarrier(e.target.value)
    }

    const handleChangeTrailer = (e) => {
        tabs[current][0] = e.target.value
        setTabs(tabs)
        tabs[current][6] = ""
        setTrailer(e.target.value)
    }

    function handleChangeRadio(e) {
        setView(e)
        tabs[current][1] = e
        setTabs(tabs)
    }

    $(function () {
        setBindings();

        $('.tab-container .tab-strip').mouseleave(function () {
            rearrangeTabs($(this));
        });

        // $('.tab .tab-button').off().click(function() {
        //     tabSwitch($(this).parent().attr('id'))
        // });
        try {
            rearrangeTabs($('.tab-container .tab-strip'));
        }
        catch (err) {
            console.log(err)
        }

    });

    function setBindings() {
        $('.tab-container .tab-strip .tab .tab-button').off().click(function () {
            $(this)
                .parent().parent()
                .children('.tab')
                .removeClass('active');
            $(this).parent().addClass('active');
            tabSwitch($(this).parent().attr('id'))
        });

        $('.tab-container .tab-strip .tab .tab-close').off().click(function () {
            //$(this).parent().css('z-index', '-1');
            delete tabs[$(this).parent().attr('id')]
            $(this).parent().animate({
                opacity: 'hide'
            }, { duration: 200, queue: false });
            $(this).parent().animate(
                {
                    width: 'hide',
                    marginLeft: 'hide',
                    marginRight: 'hide',
                    paddingLeft: 'hide',
                    paddingRight: 'hide',
                    borderLeft: 'hide',
                    borderRigh: 'hide'
                }, 300, function () {
                    var tabStrip = $(this).parent();
                    $(this).remove();
                    rearrangeTabs(tabStrip, true);
                });
        });
    }

    function rearrangeTabs(tabStrip, keepWidth) {
        if (tabStrip.children('.tab').length < 2) {
            tabStrip.children('.tab').addClass('no-close');
        }
        if (tabStrip.children('.tab.active').length === 0) {
            $(tabStrip.children('.tab')[0]).addClass('active');
            setCurrent($(tabStrip.children('.tab')[0]).attr('id'));
        }
        if (!keepWidth) {
            tabStrip.children('.tab').css('max-width', 140 + "px");
        }
    }

    function timeDateSelected(time, value) {
        setMasterDate(value)
    }


    const zoneSelectedParent = (zone) => {
        if (zone === "") {
            return
        }
        tabs[current][8] = zone
        tabs[current][9] = zones.find(x => x.id === zone).name
    }

    const submit2 = async () => {
        try {
            var start = new Date(master_date).getTime();
            var end = start;

            for (const index in tabs) {
                if (tabs[index][21] === "1") {
                    end += tabs[index][20] * 60000 * 60;
                } else {
                    end += tabs[index][20] * 60000;
                }
            }

            
            // Attributes
            let attributes = [];
            if (carrier !== 0 && carrier !== "0") {
                attributes.push({
                    id: 89,
                    value: carrier,
                    active: true
                })
            }

            // Recurrence
            let when = {
                "type": "single",
                "datetime": new Date(master_date).getTime()
            };
            var recurring = false

            let schedule = {
                active: true,
                type_id: 6,
                status_id: 2,
                name: {
                    en: "",
                    fr: "",
                },
                description: {
                    en: "",
                    fr: "",
                },
                "company_id": 2,
                "color_id": 0,
                "json": "string",
                "attributes": attributes,
                recurring,
                site_id: filters["site"],
                starts_on: start,
                ends_on: end,
            };

            var all_events = []


            const type_map = { "drop": 7, "pickup": 8, "live load": 9, "live unload": 10, "miscellaneous": 11, "switch": 12 }

            var relative_time_minutes = 0;

            for (const index in tabs) {
                var z = [];
                if (tabs[index][8] !== "") {
                    z = [{ zone_id: tabs[index][8], active: true }]
                }

                var attr = []

                for (const i in tabs[index][11]) {
                    attr.push({
                        "id": 78,
                        "value": tabs[index][11][i]
                    })
                }

                var profiles = []

                if (tabs[index][23] !== "") { //if driver add it.
                    profiles.push(
                        {
                            "profile_id": tabs[index][23]["id"],
                            "association_type_id": 1,
                            "active": true
                        }
                    )
                }

                if (tabs[index][24] !== "") { //if vehicle add it.
                    profiles.push(
                        {
                            "profile_id": tabs[index][24]["id"],
                            "association_type_id": 2,
                            "active": true
                        }
                    )
                }

                if (tabs[index][6] !== "") { //if vehicle add it.
                    profiles.push(
                        {
                            "profile_id": tabs[index][6]["id"],
                            "association_type_id": 3,
                            "active": true
                        }
                    )

                    attr.push({
                        "id": 108,
                        "value": parseInt(tabs[index][1])
                    })
                }

                if (tabs[index][21] === "1") {
                    var duration = tabs[index][20] * 60000 * 60;
                } else {
                    var duration = tabs[index][20] * 60000;
                }

                all_events.push({
                    event_type_id: tabs[index][22],
                    status_id: 2,
                    relative_time_minutes: relative_time_minutes,
                    duration: duration,
                    active: true,
                    profiles: profiles,
                    zones: z,
                    attributes: attr
                })

                if (tabs[index][21] === "1") {
                    relative_time_minutes += tabs[index][20] * 60000 * 60;
                } else {
                    relative_time_minutes += tabs[index][20] * 60000;
                }
                
            }

            let occurrences = {
                schedule_id: get(schedule, ["id"]),
                "active": true,
                "color_id": 1,
                occurrences:
                {
                    when,
                    status_id: 2,
                    attributes,
                    events: all_events,
                }
            };

            //await fetchPost("schedules/occurrences", occurrences);

            for (const index in tabs) {
                for (const j in tabs[index][5]) {
                    if (tabs[index][5][j] !== "") {
                        var file = tabs[index][5][j]
                        var formdata = new FormData();
                        formdata.append("file", file, /[^\\]*$/.exec(file.name)[0]);
                        formdata.append("attributes", JSON.stringify({ filename: /[^\\]*$/.exec(file.name)[0], type: tabs[index][10][j], number: tabs[index][11][j] }));
                        var requestOptions = {
                            method: 'POST',
                            body: formdata,
                            redirect: 'follow'
                        };
                        console.log("send")
                        fetch("http://99.79.26.232:80/uploads", requestOptions)
                            .then(response => response.text())
                            .then(result => console.log(result))
                            .catch(error => console.log('error', error));
                    }
                }
            }

            var payload = Object.assign(schedule, occurrences)
            await fetchPost("schedules", payload).then(data=> {
                dispatch(
                    setSchedulerFilters(
                        "MDC",
                        update(filters, {
                        startDate: {
                            $set: new Date(Date.parse(data.starts_on)),
                        },
                        })
                    )
                );
                setOpen(false)
            }).catch(err => {
                return 
            })



        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div>
            <Dialog open={true} onClose={handleClose} classes={{ paper: classes.dialogPaper }}>
                <Dialog open={timeZone}>
                    <TimeZone setOpen={openTimeZone} site={filters["site"]} zoneSelectedParent={zoneSelectedParent} zone={tabs[current][8]} master_date={master_date} />
                </Dialog>
                <DialogTitle style={{ position: "relative", textAlign: "center" }}>
                    <span style={{ fontSize: "16px", color: colors.black87, fontWeight: 500 }}>{I18n.get("newvisit").toUpperCase()}</span>
                </DialogTitle>
                <CloseIcon closeFunction={handleClose} style={{ position: "relative", top: "-50px", left: "860px" }} />
                <div style={{ position: "relative", textAlign: "center", top: "-40px" }}>
                    <span className="page_info_title_s2" style={{ borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#5f00a0", fontSize: "16px", fontWeight: 600 }} onClick={() => { setSummary(false) }}>{I18n.get("activities")}</span>
                    <span className="page_info_title_s2" style={{ fontSize: "16px", borderBottomWidth: "1px", borderBottomStyle: "solid", borderBottomColor: "#dddddd", cursor: "pointer" }} onClick={() => { setSummary(true) }}>&nbsp;&nbsp;&nbsp;{I18n.get("summary")}</span>
                </div>
                <div style={{ position: "relative", top: "-10px", zIndex: 1 }}>
                    <div style={{ float: "left", marginRight: "30px" }}>
                        <div style={{ position: "relative", textAlign: "left", top: -15 }}>
                            <DialogContent style={{ fontSize: "16px", fontWeight: 500, maxWidth: 228 }}>
                                <FormSection
                                    formValue={[get(filters, ["site"]) || ""]}
                                    setFormValue={handleFiltersChange}
                                    title={"site"}
                                    id={"site"}
                                    type="select"
                                    options={{
                                        categories: true,
                                        options: map(companies, (c) => ({
                                            ...c,
                                            options: get(c, ["sites"]),
                                        })),
                                    }}
                                />
                            </DialogContent>
                            <DialogContent style={{ fontSize: "16px", fontWeight: 500 }}>
                                <span style={{ color: "red", position: "relative", top: "-2px" }}>* </span><span style={{ fontWeight: "bold", position: "relative", top: "-2px" }}>{I18n.get("dashboard_carrier")}</span><br></br>
                                <NativeSelect
                                    id="demo-customized-select-native"
                                    value={carrier}
                                    style={{ width: "180px" }}
                                    onChange={handleChangeCarrier}
                                    inputProps={{
                                        className: props.classes.select,
                                    }}
                                    input={
                                        <OutlinedInput
                                            fullWidth
                                            name="language"
                                            id="language-select"
                                            className={props.classes.input}
                                        />
                                    }
                                    variant="outlined"
                                >
                                    <option aria-label="None" value={0} />
                                    {carriers.map((item, i) => {
                                        return [
                                            <option value={item["id"]}>{item["name_en"]}</option>
                                        ]
                                    }
                                    )
                                    }
                                </NativeSelect>
                            </DialogContent>
                            <DialogContent style={{ fontSize: "16px", zIndex: 5 }}>
                                <span style={{ fontWeight: "bold", position: "relative", top: "-2px" }}>{I18n.get("req_date")}</span><br></br>
                                <DatePicker
                                    name="date"
                                    value={master_date}
                                    onChange={timeDateSelected}
                                    width="100%"
                                />
                            </DialogContent>
                            <DialogContent style={{ zIndex: 10, top: -25 }}>
                                {details === false ? <Button onClick={() => { toggleDetails(true); }} style={{ background: "transparent", border: "none !important" }}><span>&#9654; <b>{I18n.get("profiles_details")}</b></span></Button> :
                                    <div>
                                        <Button onClick={() => { toggleDetails(false) }} style={{ background: "transparent", border: "none !important" }}><span>&#9660; <b>{I18n.get("profiles_details")}</b></span></Button>
                                        <br /><span><b>{I18n.get("name_reservation")}</b></span><br />
                                        <CustomInput
                                            name="reservation_name"
                                            value={reservationName}
                                            onChange={(e) => setReservationName(e.target.value)}
                                            reservation={true}
                                        />
                                        <FormSection
                                            title2={I18n.get("site_zoneColor")}
                                            id={"sys_color_id"}
                                            formValue={[reservationColor]}
                                            setFormValue={(id, index, value) => { setReservationColor(value) }}
                                            type="select"
                                            options={{
                                                color: true,
                                                options: map(master_colors, (c) => ({
                                                    id: get(c, ["id"]),
                                                    name: get(c, ["rgb"]),
                                                })),
                                            }}
                                            style={{ maxWidth: "180px", paddingTop: 10 }}
                                        />
                                        <span><b>{I18n.get("site_description")}</b></span><br />
                                        <textarea
                                            value={reservationDescription}
                                            onChange={(e) => { setReservationDescription(e.target.value) }}
                                            style={{ width: 180, height: 100, resize: "none" }}
                                        />
                                    </div>
                                }
                            </DialogContent>
                        </div>
                    </div>

                    <div style={{ position: "relative", top: "-50px", float: "right", right: 120 }}>
                        <div class="container">
                            <div class="tab-container">
                                <div class="tab-strip" style={{ position: "relative", right: 1, width: 565 }}>
                                    <span class="tab" id="0">
                                        <button class="tab-button"><span><p className={classes.tabStyle}>{I18n.get("dashboard_entrance")}</p></span></button>
                                    </span>
                                    {
                                        typeId == 12 ? 
                                        <>
                                            <span class="tab" id="1">
                                                    <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.drop} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get("drop")}</p></span></button>
                                            </span>
                                            <span class="tab" id="2">
                                                    <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.pickup} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get("pick up")}</p></span></button>
                                            </span>
                                            <span class="tab" id="3">
                                                <button class="tab-button"><span><p className={classes.tabStyle}>{I18n.get("dashboard_exit")}</p></span></button>
                                            </span>
                                        </>
                                        : 
                                        <>
                                        <span class="tab" id="1">
                                            {type === "drop" && <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.drop} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get(type)}</p></span></button>}
                                            {type === "pick up" && <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.pickup} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get(type)}</p></span></button>}
                                            {type === "live load" && <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.liveload} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get(type)}</p></span></button>}
                                            {type === "live unload" && <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.liveunload} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get(type)}</p></span></button>}
                                            {type === "move" && <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.move} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get(type)}</p></span></button>}
                                            {type === "load" && <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.load} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get(type)}</p></span></button>}
                                            {type === "unload" && <button class="tab-button"><span><p className={classes.tabStyle}><img src={images.unload} alt="plus" style={{ marginRight: "6px", position: "relative", top: "-3px" }} />{I18n.get(type)}</p></span></button>}
                                            {type === "miscellaneous" && <button class="tab-button"><span><p className={classes.tabStyle}>{I18n.get(type)}</p></span></button>}
                                            {type === "person_visit" && <button class="tab-button"><span><p className={classes.tabStyle}>{I18n.get(type)}</p></span></button>}
                                        </span>
                                        <span class="tab" id="2">
                                            <button class="tab-button"><span><p className={classes.tabStyle}>{I18n.get("dashboard_exit")}</p></span></button>
                                        </span>
                                        </>
                                    }

                                </div>
                                <div class="tabs-content" style={{ height: tabsHeight }}>
                                    <div style={{ width: "545px", height: "140px", backgroundColor: "#f8f8f8", marginBottom: "8px" }}>
                                        <img src={images.what} alt="what" style={{ position: "relative", left: "-250px", top: "25px" }} />
                                        <div style={{ position: "relative", top: "-10px", marginLeft: "43px", textAlign: "left" }}>
                                            <div style={{ position: "relative", float: "left" }}>
                                                <p style={{ color: "black", fontWeight: 500 }}>{I18n.get("what_to")}{I18n.get(type)}</p>
                                                <DialogContent style={{ fontSize: "16px", fontWeight: 500, position: "relative", float: "left", paddingRight: 10, top: -7 }}>
                                                    <NativeSelect
                                                        id="demo-customized-select-native"
                                                        value={trailer}
                                                        style={{ width: "180px", position: "relative", right: "23px", float: "left" }}
                                                        onChange={handleChangeTrailer}
                                                        inputProps={{
                                                            className: props.classes.select,
                                                        }}
                                                        input={
                                                            <OutlinedInput
                                                                fullWidth
                                                                name="language"
                                                                id="language-select"
                                                                className={props.classes.input}
                                                            />
                                                        }
                                                        variant="outlined"
                                                    >
                                                        <option aria-label="None" value="" />
                                                        <option value={3}>Trailer</option>
                                                        <option value={4}>Container</option>
                                                    </NativeSelect>
                                                </DialogContent>
                                            </div>
                                            <Grid alignItems="flex-end">
                                                {trailer === 3 ? <div style={{ position: "relative", float: "right" }}>
                                                    <div style={size(
                                                        filter(
                                                            get(formValues, ["profiles"]),
                                                            (p) => get(p, ["type", "id"]) === 3
                                                        )
                                                    ) === 0 ? { position: "relative", float: "right", right: 15, top: -72, width: 280 } : { position: "relative", float: "right", right: 5, top: -80 }}>
                                                        {size(
                                                            filter(
                                                                get(formValues, ["profiles"]),
                                                                (p) => get(p, ["type", "id"]) === 3
                                                            )
                                                        ) === 0 ? (
                                                            <ProfileSearchInput
                                                                profileType={3}
                                                                title2={"Trailer"}
                                                                selectProfile={(profile) =>
                                                                    handleChange("addProfile", null, profile)
                                                                }
                                                                noMinHeight
                                                                excludeProfileIds={excludeProfileIds}
                                                            />
                                                        ) : (
                                                            renderProfile(
                                                                get(
                                                                    filter(
                                                                        get(formValues, ["profiles"]),
                                                                        (p) => get(p, ["type", "id"]) === 3
                                                                    ),
                                                                    [0]
                                                                )
                                                            )
                                                        )}
                                                    </div>
                                                    <RadioGroup
                                                        row
                                                        aria-label="position"
                                                        name="position"
                                                        value={view}
                                                        onChange={(e) => handleChangeRadio(e.target.value)}
                                                        style={size(
                                                            filter(
                                                                get(formValues, ["profiles"]),
                                                                (p) => get(p, ["type", "id"]) === 3
                                                            )
                                                        ) === 0 ? { position: "relative", left: 165, float: "left", top: -15 } : { position: "relative", left: 175, float: "left", top: 8 }}
                                                    >
                                                        <FormControlLabel
                                                            value={'0'}
                                                            control={
                                                                <Radio
                                                                    color="primary"
                                                                    classes={{ root: classes.radioRoot }}
                                                                />
                                                            }
                                                            style={{ position: "relative", left: "15px" }}
                                                            label={<Typography style={{ fontSize: "16px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>{I18n.get("empty")}</Typography>}
                                                            labelPlacement="end"
                                                            classes={{ label: classes.radio }}
                                                        />
                                                        <FormControlLabel
                                                            value={'1'}
                                                            control={
                                                                <Radio
                                                                    color="primary"
                                                                    classes={{ root: classes.radioRoot }}
                                                                />
                                                            }
                                                            style={{ position: "relative", left: "15px" }}
                                                            label={<Typography style={{ fontSize: "16px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>{I18n.get("loaded")}</Typography>}
                                                            labelPlacement="end"
                                                            classes={{ label: classes.radio }}
                                                        />
                                                    </RadioGroup>
                                                </div> :
                                                    <div style={{ position: "relative", float: "right" }}>
                                                        <div style={size(
                                                            filter(
                                                                get(formValues, ["profiles"]),
                                                                (p) => get(p, ["type", "id"]) === 4
                                                            )
                                                        ) === 0 ? { position: "relative", float: "right", right: 15, top: -72, width: 280 } : { position: "relative", float: "right", right: 5, top: -80 }}>
                                                            {size(
                                                                filter(
                                                                    get(formValues, ["profiles"]),
                                                                    (p) => get(p, ["type", "id"]) === 4
                                                                )
                                                            ) === 0 ? (
                                                                <ProfileSearchInput
                                                                    profileType={4}
                                                                    title2={"Container"}
                                                                    selectProfile={(profile) =>
                                                                        handleChange("addProfile", null, profile)
                                                                    }
                                                                    noMinHeight
                                                                    excludeProfileIds={excludeProfileIds}
                                                                />
                                                            ) : (
                                                                renderProfile(
                                                                    get(
                                                                        filter(
                                                                            get(formValues, ["profiles"]),
                                                                            (p) => get(p, ["type", "id"]) === 4
                                                                        ),
                                                                        [0]
                                                                    )
                                                                )
                                                            )}
                                                        </div>
                                                        <RadioGroup
                                                            row
                                                            aria-label="position"
                                                            name="position"
                                                            value={view}
                                                            onChange={(e) => handleChangeRadio(e.target.value)}
                                                            style={size(
                                                                filter(
                                                                    get(formValues, ["profiles"]),
                                                                    (p) => get(p, ["type", "id"]) === 4
                                                                )
                                                            ) === 0 ? { position: "relative", left: 165, float: "left", top: -15 } : { position: "relative", left: 175, float: "left", top: 8 }}
                                                        >
                                                            <FormControlLabel
                                                                value={'0'}
                                                                control={
                                                                    <Radio
                                                                        color="primary"
                                                                        classes={{ root: classes.radioRoot }}
                                                                    />
                                                                }
                                                                style={{ position: "relative", left: "15px" }}
                                                                label={<Typography style={{ fontSize: "16px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>{I18n.get("empty")}</Typography>}
                                                                labelPlacement="end"
                                                                classes={{ label: classes.radio }}
                                                            />
                                                            <FormControlLabel
                                                                value={'1'}
                                                                control={
                                                                    <Radio
                                                                        color="primary"
                                                                        classes={{ root: classes.radioRoot }}
                                                                    />
                                                                }
                                                                style={{ position: "relative", left: "15px" }}
                                                                label={<Typography style={{ fontSize: "16px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>{I18n.get("loaded")}</Typography>}
                                                                labelPlacement="end"
                                                                classes={{ label: classes.radio }}
                                                            />
                                                        </RadioGroup>
                                                    </div>}
                                            </Grid>
                                        </div>
                                    </div>
                                    <div style={size(
                                        filter(
                                            get(formValues, ["profiles"]),
                                            (p) => get(p, ["type", "id"]) === 3
                                        )
                                    ) !== 0 || size(
                                        filter(
                                            get(formValues, ["profiles"]),
                                            (p) => get(p, ["type", "id"]) === 4
                                        )
                                    ) !== 0 ? tabs[current][8] !== "" ? { width: "545px", height: 96, backgroundColor: "#f8f8f8", display: "flex", padding: 10, top: -50, position: "relative" } : { width: "545px", height: 96, backgroundColor: "#f8f8f8", display: "flex", padding: 10, top: -50, position: "relative", border: "1px solid red", borderRadius: 5 } : tabs[current][8]!== "" ? { width: "545px", height: 96, backgroundColor: "#f8f8f8", display: "flex", padding: 10, top: -25, position: "relative" } : { width: "545px", height: 96, backgroundColor: "#f8f8f8", display: "flex", padding: 10, top: -25, position: "relative", border: "1px solid red", borderRadius: 5 }}>
                                        <div style={{ top: "10px", right: 22 }}>
                                            <Button
                                                onClick={() => { openTimeZone(true) }}
                                                color="primary"
                                                id="date_time"
                                                style={{ left: 20, top: -10 }}
                                            >
                                                {I18n.get("select_time_date")}
                                            </Button>
                                            {tabs[current][8] !== "" ? <div style={{ top: -5, left: 25 }}>
                                                <img src={images.locationIcon} alt="location" style={{ position: "absolute" }} />
                                                <span style={{ color: "black", left: 25 }}>{tabs[current][9]}</span>
                                            </div> : <div style={{ top: -5, left: -26  }}>
                                                <img src={images.locationIcon} alt="location" style={{ position: "absolute" }} />
                                            </div>}
                                        </div>
                                    </div>
                                    <div style={{ width: "545px", height: 120, backgroundColor: "#f8f8f8", marginBottom: "18px", position: "relative", top: -10 }}>
                                        <div style={{float: "left"}}>
                                            <DialogContent style={{ width: 258, overflowY: "inherit" }}>
                                                {size(
                                                    filter(
                                                        get(formValues2, ["profiles"]),
                                                        (p) => get(p, ["type", "id"]) === 1
                                                    )
                                                ) === 0 ? (
                                                    <ProfileSearchInput
                                                        profileType={1}
                                                        title={"driver"}
                                                        selectProfile={(profile) =>
                                                            handleChange("addProfile", 1, profile)
                                                        }
                                                        noMinHeight
                                                        excludeProfileIds={excludeProfileIds}
                                                    />
                                                ) : (
                                                    renderProfile2(
                                                        get(
                                                            filter(
                                                                get(formValues2, ["profiles"]),
                                                                (p) => get(p, ["type", "id"]) === 1
                                                            ),
                                                            [0]
                                                        )
                                                    )
                                                )}
                                            </DialogContent>
                                        </div>
                                        <div style={{float: "left"}}>
                                            <DialogContent style={{ width: 258, overflowY: "inherit" }}>
                                                {size(
                                                    filter(
                                                        get(formValues2, ["profiles"]),
                                                        (p) => get(p, ["type", "id"]) === 2
                                                    )
                                                ) === 0 ? (
                                                    <ProfileSearchInput
                                                        profileType={2}
                                                        title={"vehicle"}
                                                        selectProfile={(profile) =>
                                                            handleChange("addProfile", 2, profile)
                                                        }
                                                        noMinHeight
                                                        excludeProfileIds={excludeProfileIds}
                                                    />
                                                ) : (
                                                    renderProfile2(
                                                        get(
                                                            filter(
                                                                get(formValues2,["profiles"]),
                                                                (p) => get(p, ["type", "id"]) === 2
                                                            ),
                                                            [0]
                                                        )
                                                    )
                                                )}
                                            </DialogContent>
                                        </div>
                                    </div>
                                    <div style={size(
                                        filter(
                                            get(formValues, ["profiles"]),
                                            (p) => get(p, ["type", "id"]) === 3
                                        )
                                    ) !== 0 || size(
                                        filter(
                                            get(formValues, ["profiles"]),
                                            (p) => get(p, ["type", "id"]) === 4
                                        )
                                    ) !== 0 ? { width: "545px", height: 50 + tableHeight, backgroundColor: "#f8f8f8", marginBottom: "8px", position: "relative", top: -40 } : { width: "545px", height: 50 + tableHeight, backgroundColor: "#f8f8f8", marginBottom: "8px", position: "relative", top: -15 }}>
                                        <img src={images.iconPage} alt="iconpaper" style={{ left: "10px", top: "15px", position: "absolute" }} />

                                        <div style={{ top: 15, left: -180 }}>
                                            <span style={{ color: "black", left: -5, fontWeight: 500 }}>PO/BOL</span>
                                            <label>
                                                <img src={images.add} alt="add" style={{ cursor: "pointer" }} onClick={dataCreation} />
                                            </label>
                                            {/* <div>
                                                <input id="file-input" type="file" style={{ display: "none" }} onChange={uploadFile} />
                                            </div> */}
                                        </div>
                                        <span style={{ fontStyle: "italic", top: -8, right: 50, color: "black", opacity: 0.54, fontWeight: 500 }} id="dropContainer">{I18n.get("drag_drop")}</span>
                                        {
                                            currentFile.length === 0 ? <div></div> :
                                                <div>
                                                    <span className={classes.tableTitle} style={{ right: 210 }}>{I18n.get("profiles_type")}</span>
                                                    <span className={classes.tableTitle} style={{ right: 140 }}>{I18n.get("number")}</span>
                                                    <span className={classes.tableTitle} style={{ right: 40 }}>{I18n.get("file2")}</span>
                                                    {tabs[current][5].map((item, i) => {
                                                        return [
                                                            <tr key={i}>
                                                                <div style={{ height: 20, marginBottom: 30 }}>
                                                                    <NativeSelect
                                                                        id={"fileSelect" + i}
                                                                        value={currentFileData[i]}
                                                                        style={{ width: 72, top: 5, left: 10, float: "left", zIndex: 10, height: 36 }}
                                                                        onChange={handleChangePOBOL}
                                                                        inputProps={{
                                                                            className: props.classes.select,
                                                                        }}
                                                                        input={
                                                                            <OutlinedInput
                                                                                fullWidth
                                                                                name="language"
                                                                                id="language-select"
                                                                                className={props.classes.input}
                                                                            />
                                                                        }
                                                                        variant="outlined"
                                                                    >
                                                                        <option aria-label="None" value="" />
                                                                        <option value={0}>PO</option>
                                                                        <option value={1}>BOL</option>
                                                                    </NativeSelect>

                                                                    <div style={{ width: 133, top: -30, left: 110 }}>
                                                                        <CustomInput
                                                                            name="name"
                                                                            id="search-input"
                                                                            value={fileDataNumber[i]}
                                                                            onChange={(e) => handleFileNumber(e.target.value, i)}
                                                                        />
                                                                    </div>

                                                                    <span style={{ display: "flex", left: 260, top: -60, color: "#5f00a0", paddingBottom: 30 }}>{item === "" ?
                                                                        <div>
                                                                            <label for="file-input">
                                                                                <span style={{ cursor: "pointer" }}>Upload File</span>
                                                                            </label>
                                                                            <div>
                                                                                <input id="file-input" type="file" style={{ display: "none" }} onChange={(e) => uploadFile(e, i)} />
                                                                            </div>
                                                                        </div> : <div>
                                                                            <span>{/[^\\]*$/.exec(item.name)[0]}</span>
                                                                            <img className={classes.closeFile} src={images.closeIcon} alt="close" onClick={() => { tabs[current][5][i] = ""; setFile(tabs[current][5]); forceUpdate() }} />
                                                                        </div>
                                                                    }</span>
                                                                    <img src={images.delete} alt="delete" style={{ width: 14, top: 10, left: 520, cursor: "pointer", position: "absolute" }} onClick={() => {
                                                                        tabs[current][5].splice(i, 1);
                                                                        tabs[current][10].splice(i, 1);
                                                                        tabs[current][11].splice(i, 1);
                                                                        if (tabs[current][13]) {
                                                                            setTabsHeight(500 + (tabs[current][5].length * (60)) + 250)
                                                                        } else {
                                                                            setTabsHeight(500 + (tabs[current][5].length * (60)))
                                                                        }
                                                                        setTableHeight(tabs[current][5].length * 60)
                                                                        forceUpdate();
                                                                    }}></img>
                                                                </div>
                                                            </tr>,
                                                        ];
                                                    })}
                                                </div>
                                        }
                                        <div className={classes.details}>
                                            {detailsTab === false ? <Button onClick={() => { detailTabs(true); tabs[current][13] = true; }} style={{ background: "transparent", border: "none !important", width: "20%" }}><span>&#9654; <b>{I18n.get("profiles_details")}</b></span></Button> :
                                                <div>
                                                    <Button onClick={() => { detailTabs(false); tabs[current][13] = false; }} style={{ background: "transparent", border: "none !important", width: "20%" }}><span>&#9660; <b>{I18n.get("profiles_details")}</b></span></Button>
                                                    <br /><span className={classes.header}>{I18n.get("instructions")}</span><br />
                                                    <div style={{ left: 233 }}>
                                                        <CustomInput
                                                            name="instructions"
                                                            value={tabs[current][12]}
                                                            onChange={(e) => { tabs[current][12] = e.target.value; forceUpdate() }}
                                                        />
                                                    </div>
                                                    <br />
                                                    <div style={{ left: 75 }}>
                                                        <FormControlLabel className={classes.detailsCheckBox} control={<Checkbox onChange={() => { tabs[current][14] = !tabs[current][14]; forceUpdate(); }} color="blue" checked={tabs[current][14]} />} label={<Typography style={{ fontWeight: 500, fontSize: 14 }}>{I18n.get("allowed_time_before")}</Typography>} />
                                                        <div style={{ left: 60, width: 60, display: "inline-block", top: -8 }}>
                                                            <CustomInput
                                                                name="before_time"
                                                                type="number"
                                                                value={tabs[current][15]}
                                                                onChange={(e) => { tabs[current][15] = e.target.value; forceUpdate() }}
                                                            />
                                                        </div>
                                                        <div style={{ left: 60, display: "inline-block", top: 8 }}>
                                                            <RadioGroup
                                                                row
                                                                aria-label="position"
                                                                name="position"
                                                                value={tabs[current][16]}
                                                                onChange={(e) => { tabs[current][16] = e.target.value; forceUpdate() }}
                                                            >
                                                                <FormControlLabel
                                                                    value={'0'}
                                                                    control={
                                                                        <Radio
                                                                            color="primary"
                                                                            classes={{ root: classes.radioRoot }}
                                                                        />
                                                                    }
                                                                    style={{ position: "relative", left: "15px" }}
                                                                    label={<Typography style={{ fontSize: "14px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>min</Typography>}
                                                                    labelPlacement="end"
                                                                    classes={{ label: classes.radio }}
                                                                />
                                                                <FormControlLabel
                                                                    value={'1'}
                                                                    control={
                                                                        <Radio
                                                                            color="primary"
                                                                            classes={{ root: classes.radioRoot }}
                                                                        />
                                                                    }
                                                                    style={{ position: "relative", left: "10px" }}
                                                                    label={<Typography style={{ fontSize: "14px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>hr</Typography>}
                                                                    labelPlacement="end"
                                                                    classes={{ label: classes.radio }}
                                                                />
                                                            </RadioGroup>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div style={{ left: 70, top: -20 }}>
                                                        <div style={{ display: "inline-block", width: 175 }}>
                                                            <FormControlLabel className={classes.detailsCheckBox} control={<Checkbox onChange={() => { tabs[current][17] = !tabs[current][17]; forceUpdate(); }} color="blue" checked={tabs[current][17]} />} label={<Typography style={{ fontWeight: 500, fontSize: 14 }}>{I18n.get("allowed_time_after")}</Typography>} />
                                                        </div>
                                                        <div style={{ left: 67, width: 60, display: "inline-block", top: -8 }}>
                                                            <CustomInput
                                                                name="after_time"
                                                                type="number"
                                                                value={tabs[current][18]}
                                                                onChange={(e) => { tabs[current][18] = e.target.value; forceUpdate() }}
                                                            />
                                                        </div>
                                                        <div style={{ left: 67, display: "inline-block", top: 8 }}>
                                                            <RadioGroup
                                                                row
                                                                aria-label="position"
                                                                name="position"
                                                                value={tabs[current][19]}
                                                                onChange={(e) => { tabs[current][19] = e.target.value; forceUpdate() }}
                                                            >
                                                                <FormControlLabel
                                                                    value={'0'}
                                                                    control={
                                                                        <Radio
                                                                            color="primary"
                                                                            classes={{ root: classes.radioRoot }}
                                                                        />
                                                                    }
                                                                    style={{ position: "relative", left: "15px" }}
                                                                    label={<Typography style={{ fontSize: "14px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>min</Typography>}
                                                                    labelPlacement="end"
                                                                    classes={{ label: classes.radio }}
                                                                />
                                                                <FormControlLabel
                                                                    value={'1'}
                                                                    control={
                                                                        <Radio
                                                                            color="primary"
                                                                            classes={{ root: classes.radioRoot }}
                                                                        />
                                                                    }
                                                                    style={{ position: "relative", left: "10px" }}
                                                                    label={<Typography style={{ fontSize: "14px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>hr</Typography>}
                                                                    labelPlacement="end"
                                                                    classes={{ label: classes.radio }}
                                                                />
                                                            </RadioGroup>
                                                        </div>
                                                    </div>
                                                    <br />
                                                    <div style={{ left: 160, top: -50 }}>
                                                        <div style={{ display: "inline-block" }}>
                                                            <span className={classes.header}>{I18n.get("activity_duration")}</span>
                                                        </div>
                                                        <div style={{ left: 12, width: 60, display: "inline-block", top: -8 }}>
                                                            <CustomInput
                                                                name="duration"
                                                                type="number"
                                                                value={tabs[current][20]}
                                                                onChange={(e) => { tabs[current][20] = e.target.value; forceUpdate() }}
                                                            />
                                                        </div>
                                                        <div style={{ left: 12, display: "inline-block", top: 8 }}>
                                                            <RadioGroup
                                                                row
                                                                aria-label="position"
                                                                name="position"
                                                                value={tabs[current][21]}
                                                                onChange={(e) => { tabs[current][21] = e.target.value; forceUpdate() }}
                                                            >
                                                                <FormControlLabel
                                                                    value={'0'}
                                                                    control={
                                                                        <Radio
                                                                            color="primary"
                                                                            classes={{ root: classes.radioRoot }}
                                                                        />
                                                                    }
                                                                    style={{ position: "relative", left: "15px" }}
                                                                    label={<Typography style={{ fontSize: "14px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>min</Typography>}
                                                                    labelPlacement="end"
                                                                    classes={{ label: classes.radio }}
                                                                />
                                                                <FormControlLabel
                                                                    value={'1'}
                                                                    control={
                                                                        <Radio
                                                                            color="primary"
                                                                            classes={{ root: classes.radioRoot }}
                                                                        />
                                                                    }
                                                                    style={{ position: "relative", left: "10px" }}
                                                                    label={<Typography style={{ fontSize: "14px", color: "black", position: "relative", right: "5px", fontWeight: "460" }}>hr</Typography>}
                                                                    labelPlacement="end"
                                                                    classes={{ label: classes.radio }}
                                                                />
                                                            </RadioGroup>
                                                        </div>

                                                    </div>

                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ marginLeft: "360px", top: "-90px", height: 0, zIndex: 3, marginTop: 45 }}>
                    {/* <FormControlLabel control={<Checkbox onChange={() => { toggle(!checked); }} color="blue" checked={checked} />} label={I18n.get("create_another")} /> */}
                    <Button
                        onClick={handleClose}
                        color="primary"
                        style={{ marginRight: "20px", top: 5 }}
                        id="cancel"
                    >
                        {I18n.get("site_cancel")}
                    </Button>
                    <Button
                        // disabled={!allSelected()}
                        onClick={() => {
                            // setSummary(true)
                            submit2()
                            // submit(startDate, startTime, startDate, endTime, 1, 1)
                        }}
                        color="primary"
                        variant="contained"
                        id="confirm"
                    >
                        {I18n.get("site_confirm")}
                    </Button>
                </div>

            </Dialog>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        companies: get(state, ["user", "companies"]),
    };
};

export default connect(mapStateToProps)(withStyles(styles)(Reservation));
